import { Ressource, ScheduleCapacityWorkingTime, ScheduledTask } from './schedule.types'
import { LocalDate } from '../../../../utils/date/local-date'
import { DateFormat, DateUnit } from '../../../../utils/date/model/date'
import { LocalDateTime } from '../../../../utils/date/local-date-time'
import { MbscCalendarEvent } from '@mobiscroll/react'

/**
 * Renvoi la capacité de charge en minutes pour un jour donné
 * @param capacity
 * @param day
 * @return capacité en minutes
 */
export const getCapacityDurationForDay = (capacity: ScheduleCapacityWorkingTime, day: LocalDate): number => {
	const startWeek = day.startOf(DateUnit.week)

	return parseInt(capacity.semaines[startWeek.format(DateFormat.SHORT_DATE_WITH_DASH)]?.[day.format(DateFormat.SHORT_DATE_WITH_DASH)]?.total ?? '0')
}

/**
 * Renvoi la capacité de charge en minutes pour un jour et une ressource donnés
 * @param capacity
 * @param day
 * @param idRessource
 * @return capacité en minutes
 */
export const getCapacityDurationForDayAndRessource = (capacity: ScheduleCapacityWorkingTime, day: LocalDate, idRessource: string): number => {
	const startWeek = day.startOf(DateUnit.week)

	return parseInt(capacity.semaines[startWeek.format(DateFormat.SHORT_DATE_WITH_DASH)]?.[day.format(DateFormat.SHORT_DATE_WITH_DASH)]?.ressources?.[idRessource] ?? '0')
}

/**
 * Renvoi la charge travaillée en minutes pour un jour donné
 * @param tasks
 * @param day
 * @return charge travaillée en minutes
 */
export const getWorkingDurationForDay = (tasks: ScheduledTask[], day: LocalDate): number => {
	const dayTasks = tasks.filter(task => task.planned
		&& LocalDateTime.fromAPIKeepLocalTime(task.start).date.format() === day.format())

	// On prend les durées des tâches (modulo step 5)
	return dayTasks.reduce((acc, curr) => (Math.ceil(Number(curr.duree) / 5) * 5) * (curr.resource.length ?? 1) + acc, 0)
}

/**
 * Renvoi la charge travaillée en minutes pour un jour et une ressource données
 * @param tasks
 * @param day
 * @param idRessource
 * @return charge travaillée en minutes
 */
export const getWorkingDurationForDayAndRessource = (tasks: ScheduledTask[], day: LocalDate, idRessource: string): number => {
	const dayTasks = tasks.filter(task => task.planned
		&& LocalDateTime.fromAPIKeepLocalTime(task.start).date.format() === day.format()
		&& task.resource.includes(idRessource)
	)

	// On prend les durées des tâches (modulo step 5)
	return dayTasks.reduce((acc, curr) => Math.ceil(Number(curr.duree) / 5) * 5 + acc, 0)
}

/**
 * Construction de l'objet paramètre tâche envoyé lors du clic sur une card dans ScheduledTasksContainer
 *
 * @param event
 * @param eventResources
 * @param referentialRessources
 */
export const buildTaskParameters = (event: MbscCalendarEvent, eventResources: string[], referentialRessources: Ressource[]) => ({
	start: (event.start ?? '') as string,
	end: (event.end ?? '') as string,
	resources: eventResources
		.map((rId: string) => {
			const ressourceFound = referentialRessources.find(ress => ress.id === rId)
			return {
				id: ressourceFound?.userId ?? '0',
				alias: ressourceFound?.alias ?? 'N/A'
			}
		})
})